import SearchHead from "components/searchHead";
import { SEARCH_FORM_ID_ROOM_CANCEL_RESV } from "components/constent";
import { useTranslation } from "react-i18next";
import SearchForm from "./searchForm";
import RoomCancelResvList from "./list";
import { ResvCancelFilterProvider, ResvCancelParamProvider } from "./context";

export default function CancelResv() {
  const { t } = useTranslation();

  return (
    <>
      <SearchHead
        title={t("sub_ttl_resv")}
        formId={SEARCH_FORM_ID_ROOM_CANCEL_RESV}
        onClick={() => {}}
      />
      <ResvCancelParamProvider>
        <ResvCancelFilterProvider>
          <SearchForm />
        </ResvCancelFilterProvider>
        <RoomCancelResvList />
      </ResvCancelParamProvider>
    </>
  );
}
